import {
  CategorySuggestion,
  NewSuggestion,
  PageSuggestion,
  ServiceSuggestion,
  SlicedSuggestions,
  Suggestion,
  Suggestions,
} from 'types/suggestions';

type PreparedSuggestions = {
  slicedSuggestions: SlicedSuggestions | null;
  flatSuggestions: Suggestion[] | null;
};

export const prepareSuggestions = (suggestions: Suggestions | null, value: string): PreparedSuggestions => {
  if (suggestions) {
    const suggestionSlice = getSlicedSuggestions(
      suggestions.newSuggestions,
      suggestions.services,
      suggestions.categories,
    );
    const defaultSuggestionsSlice = getDefaultSlicedSuggestions(
      suggestions.newSuggestions,
      suggestions.categories,
    );

    const resultForValue = {
      slicedSuggestions: suggestionSlice,
      flatSuggestions: [...suggestionSlice[0], ...suggestionSlice[3], ...suggestionSlice[1]],
    };

    const resultForEmptyValue = {
      slicedSuggestions: defaultSuggestionsSlice,
      flatSuggestions: [
        ...defaultSuggestionsSlice[2],
        ...defaultSuggestionsSlice[0],
        ...defaultSuggestionsSlice[1],
      ],
    };

    const result = value ? resultForValue : resultForEmptyValue;

    return result;
  }

  return {
    slicedSuggestions: null,
    flatSuggestions: null,
  };
};

const MAX_SUGGESTIONS_NUMBER = 6;

export function getSlicedSuggestions(
  products: NewSuggestion[],
  services: ServiceSuggestion[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  const slicedProducts =
    services.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? products.slice(0, MAX_SUGGESTIONS_NUMBER - services.length)
      : products.slice(0, MAX_SUGGESTIONS_NUMBER / 2);
  const slicedServices =
    products.length <= MAX_SUGGESTIONS_NUMBER / 2
      ? services.slice(0, MAX_SUGGESTIONS_NUMBER - products.length)
      : services.slice(0, MAX_SUGGESTIONS_NUMBER / 2);
  const slicedCategories = categories.slice(0, MAX_SUGGESTIONS_NUMBER / 2);

  return [slicedProducts || [], slicedServices || [], [], slicedCategories || []];
}

function getDefaultSlicedSuggestions(
  products: NewSuggestion[],
  categories: CategorySuggestion[],
): SlicedSuggestions {
  const slicedProducts = products.slice(0, MAX_SUGGESTIONS_NUMBER);
  const slicedCategories = categories.slice(0, MAX_SUGGESTIONS_NUMBER);
  const defaultPages: PageSuggestion[] = [{ categoryUrl: '/promo/' }, { categoryUrl: '/uslugi/' }];
  return [slicedProducts, [], defaultPages, slicedCategories || []];
}
